define("SuiteDB.SDBQuoteImprovements.Cart.View", [
  "suitedb_sdbquoteimprovements_cart.tpl",
  "Backbone",
], function (suitedb_sdbquoteimprovements_cart_tpl, Backbone) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbquoteimprovements_cart_tpl,
    initialize: function initialize(options) {
      this.options = options;
    },
    events: {
      'click [data-action="add-to-quote"]': "addToQuote",
    },
    addToQuote: function addToQuote(e) {
      var self = this;
      e.preventDefault();
      var $target = $(e.currentTarget);
      var lineId = $target
        .closest('[data-view="Cart.AddToQuote.View"]')
        .attr("data-internalid");
      var line = this.options.LiveOrder.get("lines").get(lineId);

      var item = line.get("item");

      self.itemInternalId = item.get("internalid");
      self.quantity = line.get("quantity");
    },
    getContext: function getContext() {
      return {};
    },
  });
});
